import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Platform} from "ionic-angular";
import {GlobalProvider} from "../global/global";

@Injectable()
export class PwaIosProvider {
  headers: any;

  constructor(
    public http: HttpClient,
    private platform: Platform,
    private global: GlobalProvider,
  ) {
    console.log("Hello PwaIosProvider Provider");
    this.headers = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Access-Control-Allow-Origin", "*");
  }

  saveInstall(idUsuario) {
    let datos = {
      tipo: "pwa-" + this.platform.platforms()[1],
      uuid: "mobileweb",
      token: "No token - Iphone",
      idempleado: idUsuario
    };

    let url = this.global.URLBASEJSON + "registrar-instalacion";

    let params = new HttpParams();
    params = params.append("tipo", datos.tipo);
    params = params.append("uuid", datos.uuid);
    params = params.append("token", datos.token);
    params = params.append("idempleado", datos.idempleado);

    console.log(datos.tipo);
    console.log(datos.uuid);
    console.log(datos.token);
    console.log(datos.idempleado);

    this.http.post(url, params, this.headers).subscribe(data => {
      console.log('resp serv: ', data);
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/pwa-ios/pwa-ios.ts